import { FiltersAndTable } from '../FiltersAndTable';
import { OrgPolicyResults } from '../types/ApplicationDetailsType';

interface IProps {
  ruleSummaries: object;
  analysisId: string;
  policyViolations?: OrgPolicyResults[];
}

export function BehaviorsTab({ ruleSummaries, analysisId, policyViolations }: IProps) {
  return <FiltersAndTable analysisId={analysisId} data={ruleSummaries} filterSection="behaviors" policyViolations={policyViolations}/>;
}
